import React from 'react';

export default ({
	image,
	alt,
}) => (
	<picture className="full-width">
		<source
			srcSet={`${image}?w=2000&auto=format`}
			media="(min-width: 1400px)"
		/>
		<source
			srcSet={`${image}?w=1600&auto=format`}
			media="(min-width: 1000px)"
		/>
		<source
			srcSet={`${image}?w=1200&auto=format`}
			media="(min-width: 600px)"
		/>
		<img
			className="full-width"
			alt={alt}
			src={`${image}?w=800&auto=format`}
		/>
	</picture>
);